module.exports = __webpack_public_path__ + "media/src/img/strong-c23926845f71958b01b90ad36c46a3f1.svg";